import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgram/AdjustmentApi";
import i18n from "../../../../Frontends/Common/utils/i18n.js";
import store from "../../../../Frontends/Common/store";

export class AdjustmentService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
    this.editedFields = [];
    this.isGroupingGrid = false;
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editAdjustment", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editAdjustment");
  }
  async grid(args) {
    let params = { filter: args, isGroupingGrid: this.isGroupingGrid };
    return await this.transformer.getGrid(this.Api, "getAdjustments", params);
  }
  async get(id, periodId) {
    return await this.transformer.getGridPanel(this.Api, "getAdjustment", null, { id, periodId });
  }
  async getMany(ids, periodId) {
    let filter = "$filter=MarsPeriodId eq " + periodId + " and (" + ids.map(id => `(Id eq ${id})`).join(" or ") + ")";
    return await this.transformer.getGrid(this.Api, "getAdjustments", filter);
  }
  async getAddressProgramsByAdjustmentId(filter) {
    return await this.transformer.getGrid(this.Api, "getAddressProgramsByAdjustmentId", filter);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createAdjustment", model);
  }
  async acceptAdjustment(model) {
    return await this.transformer.editItem(this.Api, "acceptAdjustment", model);
  }
  async approveAdjustment(model) {
    return await this.transformer.editItem(this.Api, "approveAdjustment", model);
  }
  async acceptAdjustments(params) {
    return await this.transformer.editItem(this.Api, "acceptAdjustments", params);
  }
  async approveAdjustments(params) {
    return await this.transformer.editItem(this.Api, "approveAdjustments", params);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editAdjustment", model);
  }
  async updateMany(models) {
    return await this.transformer.editItem(this.Api, "editAdjustments", models);
  }
  async delete(models) {
    return await this.transformer.deleteItem(this.Api, "deleteAdjustments", models);
  }
  async getEditedFieldsConfig() {
    let data = this.editedFields || [];
    return { data: { records: data, total: data.length } };
  }
  async getTypes() {
    const types = [
      { label: i18n.global.t("adjustmentTT"), value: "adjustmentTT" },
      { label: i18n.global.t("adjustmentGroupTT"), value: "adjustmentGroupTT" },
    ]
    const data = {records: types}
    return Promise.resolve( { data })
  }
  async getEditedFields() {
    const types = [
      { label: "Сеть", value: "Сеть" },
      { label: "Адрес", value: "Адрес" },
      { label: "Область", value: "Область" },
      { label: "Город", value: "Город" },
      { label: "Географический кластер", value: "Географический кластер" },
      { label: "HSR", value: "HSR" },
      { label: "Внешний формат", value: "Внешний формат" },
      { label: "Тип точки", value: "Тип точки" },
      { label: "Канал", value: "Канал" },
      { label: "NA/RKA", value: "NA/RKA" },
      { label: "SIP-канал", value: "SIP-канал" },
      { label: "Территориальный кластер", value: "Территориальный кластер" },
      { label: "Внешний код", value: "Внешний код" },
      { label: "Тарифная зона", value: "Тарифная зона" },
      { label: "Skyline", value: "Skyline" },
      { label: "Количество визитов", value: "Кол-во визитов" },
      { label: "Тайминг на визит", value: "Тайминг на визит" },
      { label: "OSA", value: "OSA" },
      { label: "ISA-OSA", value: "ISA-OSA" },
      { label: "Ставка нормочаса", value: "Ставка нормочаса" },
      { label: "Покрытие", value: "Покрытие"},
      { label: "POG Wh Wet", value: "POG Wh Wet"},
      { label: "POG PF Wet", value: "POG PF Wet"},
      { label: "POG Sh Wet", value: "POG Sh Wet"},
      { label: "POG Wh Dry", value: "POG Wh Dry"},
      { label: "POG PF Dry", value: "POG PF Dry"},
      { label: "Представленность Марс", value: "Представленность Марс"},
      { label: "Навески Dreamies", value: "Навески Dreamies"},
      { label: "Навески PF cat", value: "Навески PF cat"},
      { label: "Навески PF dog", value: "Навески PF dog"},
      { label: "Навески с суперпремиум паучами", value: "Навески с суперпремиум паучами"},
      { label: "Бренд-блок Dreamies", value: "Бренд-блок Dreamies"},
      { label: "Бренд-блок PF cats", value: "Бренд-блок PF cats"},
      { label: "Бренд-блок PF dog", value: "Бренд-блок PF dog"},
      { label: "ДМП Grocery", value: "ДМП Grocery"},
      { label: "Прилегающая к кассам зона SPT", value: "Прилегающая к кассам зона SPT"}
    ]
    const data = {records: types}
    return Promise.resolve( { data })
  }
  async getResultFilterTypes() {
    const filter = [
      { text: i18n.global.t("adjustmentFieldAccepted"), value: 'accepted' },
      { text: i18n.global.t("adjustmentFieldDeclined"), value: 'rejected' },
      { text: i18n.global.t("partiallyAccepted"), value: 'partiallyAccepted' }
    ];
    return Promise.resolve({ data: { records: filter } });
  }
  async export(period, filter, format) {
    const res = this.Api.export(period, filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getHasAdjustmentFilterCoverage() {
    const hasAdjustmentFilterCoverage = [
      { text: i18n.global.t("inclusionInCoverage"), value: true },
      { text: i18n.global.t("exclusionFromCoverage"), value: false }
    ];
    return Promise.resolve({ data: { records: hasAdjustmentFilterCoverage } })
  }
  async gridAndParseEditedFieldsConfig(args) {
    const response = await this.grid(args);
    const transformedData = response.data.records.flatMap(element => {
      const configs = JSON.parse(element.editedFieldsConfig)

      const objs = configs.map((config, index) => ({
        id: `${element.id}-${index}`,
        name: config.name,
        key: config.key,
        adjustmentStatus: element.status,
        oldValue: config.oldValue,
        oldDisplayValue: config.oldDisplayValue,
        newValue: config.newValue,
        displayValue: config.displayValue,
        date: element.createdAt,
        acceptanceStatus: config.acceptanceStatus,
        approvalStatus: config.approvalStatus,
        outletCode: element.outletCode,
      }))

      return objs
    });

    return { data: { records: transformedData } }
  }
}
